import BLoading from './packages/BLoading'

BLoading.install = function (Vue) {
  Vue.component(BLoading.name, BLoading)
}

export default BLoading
